import { render } from "./aosPage.vue?vue&type=template&id=0473ef55"
import script from "./aosPage.vue?vue&type=script&lang=js"
export * from "./aosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__